
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stock",
      function () {
        return require("private-next-pages/stock.tsx");
      }
    ]);
  